<template>
<div>
  <div v-html="content">
  </div>
  <div class="button-area">
    <van-button type="default" size="normal" @click="refused"> 拒 绝 </van-button>
    <van-button :type="confirmType" :disabled="confirmDisabled" size="normal" class="acceptProtocol" @click="accept"> {{acceptStr}} </van-button>
  </div>
</div>
</template>

<script>
import api from '@/fetch/api';
import {
  Dialog
} from 'vant'

export default {
  data() {
    return {
      acceptStr: "10秒",
      totalTime: 10,
      confirmType: "default",
      confirmDisabled: true,
      xyState: "00",
      sysVersion:"OLD",
      content:"",
    };
  },
  mounted() {
    let clock = window.setInterval(() => {
      this.$data.totalTime--
      this.$data.acceptStr = this.$data.totalTime + '秒'
      if (this.$data.totalTime == 0) {
        window.clearInterval(clock)
        this.$data.confirmDisabled = false;
        this.$data.acceptStr = '接受';
        this.$data.confirmType = 'info';
      }
    }, 1000)

  },
  created: function() {
    document.title = "苏豪丽天智储预约排队";
    this.getsysBcInfo("appointmentxy");
    this.getxybyopenid();
    this.getSysInfo();
  },
  methods: {
    refused() {
      var that = this;
      Dialog.alert({
        message: '您未确认安全告知书，无法进行预约',
      }).then(() => {
        that.$router.push({
          name: 'index'
        })
      });
    },
    accept() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.addxybyopenid(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == "0") {
          var from = that.$route.params.from;
          var sysVersion = that.sysVersion;
          if(from)
          {
            if(sysVersion == "OLD")
            {
              if (from == 'th') {
                that.$router.push({
                  name: 'appointmentold'
                })
              } else if (from == 'xh') {
                that.$router.push({
                  name: 'appointmentxhold'
                })
              } else {
                that.$router.go(-1);
              }
            }
            else{
              that.$router.push({
                name: 'inputYyNumber',
                params: {
                  type: from,
                }
              });
            }
          }
          else{
            that.$router.go(-1);
          }
        } else {
          Dialog.alert({
            message: res.message,
          }).then(() => {

          });
        }

      });
    },
    getxybyopenid() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;

      api.getxybyopenid(openid).then(function(resData) {
        var res = JSON.parse(resData);
        that.$data.xyState = res.data;
        switch (res.data) {
          //返回0是没有安全确认，返回1已确认过了
          case 1:
            var from = that.$route.params.from;
            if(from)
            {
              that.$router.push({
                name: 'inputYyNumber',
                params: {
                  type: from,
                }
              });
            }
            else{
              that.$router.go(-1);
            }
          break;
          case 0:

            break;
        }
      });
    },
    //获取系统信息
    getSysInfo()
    {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      //获取系统信息
      api.getSysInfo(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var sysVersion = res.data.sysVersion;
          that.sysVersion = sysVersion;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },//获取系统信息
    getsysBcInfo(type)
    {
      var that = this;
      //获取系统信息
      api.getsysBcInfo(type).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var content = res.data;
          that.content = content;
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
    padding: 1rem 0.825rem 0;
    p {
        line-height: 2;
        vertical-align: baseline;
        span {
            font-size: 12px;
        }
    }
}

.button-area {
    margin: 1rem;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
        width: 50%;
        text-align: center;
        margin: 0 auto;
    }
    .acceptProtocol {
        background: #316892;
    }
}
</style>
